export const SELECT_WIDTH = 123;
export const TIME_INPUT_WIDTH = 122;
export const DATEPICKER_WIDTH = 131;
